export default "__VITE_ASSET__aaf17168__"